const events = 'vacation-events';

export default {
  events,
};
